import api from "@/api/api-v2-config";

export async function getBudgetListAxios() {
  return await api.get("budgets/budget");
}

export async function postBudgetListAxios(data) {
  return await api.post("budgets/budget", data);
}

export async function updateBudgetListAxios(data) {
  return await api.put("budgets", data);
}

export async function deleteBudgetListAxios(id) {
  return await api.delete("budgets/" + id);
}

export async function getBudgetByIdListAxios(id) {
  return await api.get("budgets/" + id);
}
